import { Link } from 'react-router-dom';

export default function AboutPage() {
  return (
    <div className="pt-16">
      {/* Hero */}
      <section className="py-24 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-orange-500/5 via-transparent to-transparent" />
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative">
          <h1 className="text-4xl sm:text-5xl font-bold text-white mb-6">
            Built for the{' '}
            <span className="gradient-text">AI Era</span>
          </h1>
          <p className="text-xl text-zinc-400">
            We're reimagining web hosting for a world where AI writes and deploys your code.
          </p>
        </div>
      </section>

      {/* Mission */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-white mb-6">Our Mission</h2>
              <p className="text-zinc-400 mb-4">
                Traditional hosting was designed for humans clicking through control panels. But the future of development is AI-assisted—where your coding assistant writes, builds, and deploys your projects.
              </p>
              <p className="text-zinc-400 mb-4">
                WISERWEB is built from the ground up for this new paradigm. We've eliminated the friction between AI coding assistants and production deployment.
              </p>
              <p className="text-zinc-400">
                No more copying credentials. No more manual deploys. Just tell your AI to ship it, and it does.
              </p>
            </div>
            <div className="bg-zinc-900/50 border border-zinc-800 rounded-2xl p-8">
              <div className="text-center">
                <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-orange-500 to-red-500 flex items-center justify-center mx-auto mb-6 shadow-glow">
                  <span className="material-icons text-white text-4xl">rocket_launch</span>
                </div>
                <h3 className="text-xl font-semibold text-white mb-2">Ship Faster</h3>
                <p className="text-zinc-400">
                  From code to production in seconds, not hours.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-16 bg-raised">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-white text-center mb-12">Our Values</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 rounded-2xl bg-orange-500/10 flex items-center justify-center mx-auto mb-4">
                <span className="material-icons text-orange-400 text-3xl">bolt</span>
              </div>
              <h3 className="text-xl font-semibold text-white mb-2">Simplicity</h3>
              <p className="text-zinc-400">
                No complex configurations. No learning curves. Just deploy and go.
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 rounded-2xl bg-cyan-500/10 flex items-center justify-center mx-auto mb-4">
                <span className="material-icons text-cyan-400 text-3xl">security</span>
              </div>
              <h3 className="text-xl font-semibold text-white mb-2">Security</h3>
              <p className="text-zinc-400">
                API key authentication, container isolation, and SSL encryption on every deployment.
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 rounded-2xl bg-green-500/10 flex items-center justify-center mx-auto mb-4">
                <span className="material-icons text-green-400 text-3xl">psychology</span>
              </div>
              <h3 className="text-xl font-semibold text-white mb-2">AI-First</h3>
              <p className="text-zinc-400">
                Every feature designed with AI coding assistants in mind.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Technology */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-white text-center mb-12">Built with Modern Tech</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="bg-zinc-900/50 border border-zinc-800 rounded-xl p-6 text-center">
              <div className="text-3xl font-bold text-orange-400 mb-2">Rust</div>
              <p className="text-sm text-zinc-500">Backend</p>
            </div>
            <div className="bg-zinc-900/50 border border-zinc-800 rounded-xl p-6 text-center">
              <div className="text-3xl font-bold text-cyan-400 mb-2">React</div>
              <p className="text-sm text-zinc-500">Frontend</p>
            </div>
            <div className="bg-zinc-900/50 border border-zinc-800 rounded-xl p-6 text-center">
              <div className="text-3xl font-bold text-blue-400 mb-2">PostgreSQL</div>
              <p className="text-sm text-zinc-500">Database</p>
            </div>
            <div className="bg-zinc-900/50 border border-zinc-800 rounded-xl p-6 text-center">
              <div className="text-3xl font-bold text-green-400 mb-2">Docker</div>
              <p className="text-sm text-zinc-500">Containers</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-raised">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-6">
            Join the Future of Deployment
          </h2>
          <p className="text-lg text-zinc-400 mb-8">
            Experience hosting that's built for how you actually work.
          </p>
          <Link
            to="/register"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 text-lg font-semibold text-white bg-gradient-to-r from-orange-500 to-red-500 rounded-xl hover:shadow-glow transition-all"
          >
            <span className="material-icons">rocket_launch</span>
            Get Started
          </Link>
        </div>
      </section>
    </div>
  );
}

